export default __webpack_public_path__ + "static/media/after@2x.a79f3346.png";